<template>
  <div class="zgbs-dialog-wrap">
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title" :btnTxt="btnTxt" v-if="!(cvipMes.cvipstate==1||cvipMes.cvipstate==10)">
      <p class="des">多场景展示：<span class="des-in">在您的求职中心、简历页面、全职招聘页面增加皇冠标识，让您的身份与众不同。</span></p>
      <div class="zgbs-bg"><img class="zgbs-bg-img" src="../../../../assets/imgs/pri-zgbs.png"></div>
    </CvipDialog>
    <CvipDialog @btnClick="vipBuy()" @close="close()" :title="title1" :btnTxt="btnTxt1" v-else>
      <p class="tit">恭喜您，已获得<span  class="tit-names">尊贵标识</span>特权</p>
      <p class="des"><span class="des-in des-use">多场景展示：在您的求职中心、简历页面、全职招聘页面增加皇冠标识，让您的身份与众不同。</span></p>
      <div class="zgbs-bg"><img class="zgbs-bg-img" src="../../../../assets/imgs/pri-zgbs.png"></div>
    </CvipDialog>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import CvipDialog from "./common/CvipDialog"
export default {
  name: 'zgbsDialog',
  components: {
    CvipDialog
  },
  data () {
    return {
      title: '尊贵标识',
      btnTxt: '开通会员尊享特权',
      title1: '',
      btnTxt1: '',
      title2: '',
      btnTxt2: '立即体验'
    }
  },
  created () {
    window.clickLog && window.clickLog(`from=pc-cvip-zgbs-tanchuang-show-${this.cvipMes.cvipstate}`)
  },
  methods: {
    // 点击支付按钮
    vipBuy () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-zgbs-ljkt-${this.cvipMes.cvipstate}`)
      this.$emit("buyDialog")
    },
    close () {
      window.clickLog && window.clickLog(`from=pc-cvip-tqtc-zgbs-close-${this.cvipMes.cvipstate}`)
      this.$emit("closeDialog")
    }
  },
  computed: mapGetters({
    cvipMes: 'cvipMes',
    rightUsed: 'rightUsed' //4：黄金亮点 5：置顶 10：尊贵标识 11：个人认证 12：求职分析 13：免费刷新 14：求职保障 15：意外保险
  })
}
</script>

<style lang="scss" scoped>
.tit{
  margin-top:80px;
}
.zgbs-bg{
  width: 606px;
  height: 290px;
  margin: 20px auto 0;
  overflow: hidden;
}
.zgbs-bg-img{
  width: 606px;
  height: 290px;
}
.des-in{
  font-size: 14px;
  color: #AAAAAA;
}
.des-use{
  width:100%;
  display:inline-block;
  text-align:center;
}
.tit{
  margin: 55px 0 8px;
  font-size: 24px;
  color: #333;
  line-height: 33px;
  text-align:center;
}
.tit-names{
  font-size: 24px;
  color: #D4B277;
  line-height: 33px;
}
</style>



// WEBPACK FOOTER //
// ZgbsDialog.vue?7eaac8e2